import { render, staticRenderFns } from "./VuesticTag.vue?vue&type=template&id=5bb28277&"
import script from "./VuesticTag.vue?vue&type=script&lang=js&"
export * from "./VuesticTag.vue?vue&type=script&lang=js&"
import style0 from "./VuesticTag.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "VuesticTag.vue"
export default component.exports